/**
 * @fileoverview Standard HTTP header names used across API requests.
 * @description Centralizes header names so request/response interceptors and services all
 * reference the same string instead of duplicating header literals.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

export const HTTP_HEADER_CORRELATION_ID = 'X-Correlation-Id'
